@use "@flixbus/honeycomb-react/dist/scss/honeycomb-helpers.scss";

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--hcr-spacing-2);
  padding: var(--hcr-spacing-6) 0;
}

.icon {
  color: var(--hcr-content-secondary-color);
}
